import React, { useMemo } from 'react';
import { NoData } from 'src/@vymo/ui/blocks';
import Dashboard from './dashboard/index';
import Leaderboard from './leaderboard/index';
import { PerformanceDashboardProps } from './types';
import styles from './index.module.scss';

function PerformanceWrapper({ tab }: PerformanceDashboardProps) {
  const tabView = useMemo(() => {
    switch (tab) {
      case 'dashboard':
        return <Dashboard />;
      case 'leaderboard':
        return <Leaderboard />;
      default:
        return <NoData message="No module found" />;
    }
  }, [tab]);

  return <div className={styles.performanceWrapper}>{tabView}</div>;
}

export default PerformanceWrapper;
